export default {
    permission: {
        admin: 'Administrateur',

        entity_index: 'Lister les objets',
        entity_show: 'Afficher un objet',
        entity_store: 'Créer un objet',
        entity_update: 'Mettre à jour un objet',
        entity_destroy: 'Supprimer un objet',

    },
}
